import { render, staticRenderFns } from "./StockScanner.vue?vue&type=template&id=31ca06c0"
import script from "./StockScanner.vue?vue&type=script&lang=ts"
export * from "./StockScanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31ca06c0')) {
      api.createRecord('31ca06c0', component.options)
    } else {
      api.reload('31ca06c0', component.options)
    }
    module.hot.accept("./StockScanner.vue?vue&type=template&id=31ca06c0", function () {
      api.rerender('31ca06c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/StockScanner.vue"
export default component.exports